import { combineReducers } from 'redux';
import { urlsWrapper } from 'config';
import { serialize } from 'utils';
import { createAction } from 'redux-actions';
import {
  RESET_TYPES,
  createCommonListConstants,
  createCommonListReducer,
  createCommonItemConstants,
  createCommonItemReducer,
  saveData,
} from './utils';
import { commonGet } from './api';

const POLL_INTERVAL = 1000;
const POLL_COUNTS = 5;

const divisionWeatherAggregates = createCommonItemConstants(
  'DIVISION_WEATHER_AGGREGATES'
);
const divisionWeatherHistory = createCommonItemConstants(
  'DIVISION_WEATHER_HISTORY'
);
const divisionWeatherAlerts = createCommonListConstants(
  'DIVISION_WEATHER_ALERTS'
);
const weatherGeojson = createCommonItemConstants('DIVISION_WEATHER_GEOJSON');
const divisionWeatherCurrent = createCommonListConstants(
  'DIVISION_WEATHER_CURRENT'
);
const divisionWeatherForecast = createCommonListConstants(
  'DIVISION_WEATHER_FORECAST'
);
const fieldWeatherCurrent = createCommonListConstants('FIELD_WEATHER_CURRENT');
const fieldWeatherForecast = createCommonListConstants(
  'FIELD_WEATHER_FORECAST'
);
const fieldWeatherAggregates = createCommonItemConstants(
  'FIELD_WEATHER_AGGREGATES'
);
const fieldWeatherHistory = createCommonItemConstants('FIELD_WEATHER_HISTORY');
const fieldWeatherAlerts = createCommonListConstants('FIELD_WEATHER_ALERTS');
const divisionWeatherSources = createCommonListConstants(
  'DIVISION_WEATHER_SOURCE'
);
const fieldWeatherMultiyear = createCommonItemConstants(
  'FIELD_WEATHER_MULTIYEAR'
);
const divisionWeatherMultiyear = createCommonItemConstants(
  'DIVISION_WEATHER_MULTIYEAR'
);
const weatherAlertsError = createCommonItemConstants('WEATHER_ALERTS_ERROR');

// reducer
export default combineReducers({
  divisionWeatherCurrent: createCommonListReducer(divisionWeatherCurrent),
  divisionWeatherForecast: createCommonListReducer(divisionWeatherForecast),
  divisionWeatherAggregates: createCommonItemReducer(divisionWeatherAggregates),
  divisionWeatherHistory: createCommonItemReducer(divisionWeatherHistory),
  divisionWeatherAlerts: createCommonListReducer(divisionWeatherAlerts),
  fieldWeatherCurrent: createCommonListReducer(fieldWeatherCurrent),
  fieldWeatherForecast: createCommonListReducer(fieldWeatherForecast),
  fieldWeatherAggregates: createCommonItemReducer(fieldWeatherAggregates),
  fieldWeatherHistory: createCommonItemReducer(fieldWeatherHistory),
  fieldWeatherAlerts: createCommonListReducer(fieldWeatherAlerts),
  weatherGeojson: createCommonItemReducer(weatherGeojson),
  divisionWeatherSources: createCommonListReducer(divisionWeatherSources),
  weatherAlertsError: createCommonItemReducer(weatherAlertsError),
  fieldWeatherMultiyear: createCommonItemReducer(fieldWeatherMultiyear),
  divisionWeatherMultiyear: createCommonItemReducer(divisionWeatherMultiyear),
});

// Новая функция для получения многолетних данных о погоде для поля
export function getFieldWeatherMultiyear(fieldId, params, sourceId) {
  return saveData(
    `${urlsWrapper(
      'fields'
    )}/${fieldId}/weather/${sourceId}/multiyear?${serialize(params)}`,
    fieldWeatherMultiyear.SET_ITEM,
    fieldWeatherMultiyear.SET_IS_PENDING,
    RESET_TYPES.ITEM
  );
}

// Новая функция для получения многолетних данных о погоде для хозяйства
export function getDivisionWeatherMultiyear(divisionId, params, sourceId) {
  return saveData(
    `${urlsWrapper(
      'divisions'
    )}/${divisionId}/weather/${sourceId}/multiyear?${serialize(params)}`,
    divisionWeatherMultiyear.SET_ITEM,
    divisionWeatherMultiyear.SET_IS_PENDING,
    RESET_TYPES.ITEM
  );
}

// actions
export function getDivisionWeatherCurrent(divisionId, sourceId) {
  return saveData(
    `${urlsWrapper('divisions')}/${divisionId}/weather/${sourceId}/current`,
    divisionWeatherCurrent.SET_LIST,
    divisionWeatherCurrent.SET_IS_PENDING,
    RESET_TYPES.ITEM
  );
}

export function getDivisionWeatherForecast(divisionId, sourceId) {
  return saveData(
    `${urlsWrapper('divisions')}/${divisionId}/weather/${sourceId}/forecast`,
    divisionWeatherForecast.SET_LIST,
    divisionWeatherForecast.SET_IS_PENDING,
    RESET_TYPES.LIST
  );
}

export function getFieldWeatherCurrent(fieldId, sourceId) {
  return saveData(
    `${urlsWrapper('fields')}/${fieldId}/weather/${sourceId}/current`,
    fieldWeatherCurrent.SET_LIST,
    fieldWeatherCurrent.SET_IS_PENDING
  );
}

export function getFieldWeatherForecast(fieldId, sourceId) {
  return saveData(
    `${urlsWrapper('fields')}/${fieldId}/weather/${sourceId}/forecast`,
    fieldWeatherForecast.SET_LIST,
    fieldWeatherForecast.SET_IS_PENDING
  );
}

export function getDivisionWeatherAggregates(divisionId, params, sourceId) {
  return saveData(
    `${urlsWrapper(
      'divisions'
    )}/${divisionId}/weather/${sourceId}/aggregate?${serialize(params)}`,
    divisionWeatherAggregates.SET_ITEM,
    divisionWeatherAggregates.SET_IS_PENDING,
    RESET_TYPES.ITEM
  );
}

export function getDivisionWeatherAggregatesWithoutSave({
  divisionId,
  params,
  sourceId,
}) {
  return commonGet({
    url: `${urlsWrapper(
      'divisions'
    )}/${divisionId}/weather/${sourceId}/aggregate?${serialize(params)}`,
  });
}

export function getDivisionWeatherHistory(divisionId, params, sourceId) {
  return saveData(
    `${urlsWrapper(
      'divisions'
    )}/${divisionId}/weather/${sourceId}/history?${serialize(params)}`,
    divisionWeatherHistory.SET_ITEM,
    divisionWeatherHistory.SET_IS_PENDING,
    RESET_TYPES.ITEM
  );
}

export function getFieldWeatherAggregates(fieldId, params, sourceId) {
  return saveData(
    `${urlsWrapper(
      'fields'
    )}/${fieldId}/weather/${sourceId}/aggregate?${serialize(params)}`,
    fieldWeatherAggregates.SET_ITEM,
    fieldWeatherAggregates.SET_IS_PENDING,
    RESET_TYPES.ITEM
  );
}

export function getFieldWeatherAggregatesWithoutSave({
  fieldId,
  params,
  sourceId,
}) {
  return commonGet({
    url: `${urlsWrapper(
      'fields'
    )}/${fieldId}/weather/${sourceId}/aggregate?${serialize(params)}`,
  });
}

// Почасовая история погоды (модельные данные, dt в таймзоне источника)
// Бэк: /v1/customers/{}/fields/{}/weather/{}/history/hourly
export function getFieldWeatherHistoryHourly({ fieldId, params, sourceId }) {
  return commonGet({
    url: `${urlsWrapper(
      'fields'
    )}/${fieldId}/weather/${sourceId}/history/hourly?${serialize(params)}`,
  });
}

// Бэк: /v1/customers/{}/divisions/{}/weather/{}/history/hourly
export function getDivisionWeatherHistoryHourly({
  divisionId,
  params,
  sourceId,
}) {
  return commonGet({
    url: `${urlsWrapper(
      'divisions'
    )}/${divisionId}/weather/${sourceId}/history/hourly?${serialize(params)}`,
  });
}

export function getFieldWeatherHistory(fieldId, params, sourceId) {
  return saveData(
    `${urlsWrapper(
      'fields'
    )}/${fieldId}/weather/${sourceId}/history?${serialize(params)}`,
    fieldWeatherHistory.SET_ITEM,
    fieldWeatherHistory.SET_IS_PENDING
  );
}

export function getWeatherGeojson() {
  return saveData(
    `${urlsWrapper('weatherGeojson')}`,
    weatherGeojson.SET_ITEM,
    weatherGeojson.SET_IS_PENDING
  );
}

// Only an active polling session is shared, scoped to the Redux store.
const alertRequests = new WeakMap();

export const stopWeatherAlerts = () => (dispatch) => {
  const request = alertRequests.get(dispatch);
  if (!request) return;
  request.active = false;
  clearTimeout(request.timer);
  alertRequests.delete(dispatch);
  dispatch(request.setIsPending(false));
};

export const setWeatherAlertsError = (error) => (dispatch) => {
  dispatch(createAction(weatherAlertsError.SET_ITEM)(error));
};

export const getWeatherAlerts =
  (url, setItem, setIsPending) => async (dispatch) => {
    dispatch(stopWeatherAlerts());
    const request = { active: true, timer: null, attempts: 0, setIsPending };
    alertRequests.set(dispatch, request);
    dispatch(setItem([]));
    dispatch(setIsPending(true));
    dispatch(setWeatherAlertsError(null));
    const isCurrent = () =>
      request.active && alertRequests.get(dispatch) === request;
    const finish = () => {
      if (isCurrent()) dispatch(stopWeatherAlerts());
    };
    const poll = async () => {
      request.attempts += 1;
      try {
        const response = await commonGet({ url });
        if (!isCurrent()) return;
        dispatch(setItem(response.data));
        finish();
      } catch (error) {
        if (!isCurrent()) return;
        const err = error?.errors?.err || { status: null };
        if (err.status === 429 && request.attempts <= POLL_COUNTS) {
          // Schedule only after the response; slow requests must not overlap.
          request.timer = setTimeout(poll, POLL_INTERVAL);
        } else {
          finish();
          dispatch(setWeatherAlertsError(err));
        }
      }
    };
    await poll();
  };

export function getDivisionWeatherAlerts(divisionId, params, sourceId) {
  return getWeatherAlerts(
    `${urlsWrapper(
      'divisions'
    )}/${divisionId}/weather/${sourceId}/alerts?${serialize(params)}`,
    createAction(divisionWeatherAlerts.SET_LIST),
    createAction(divisionWeatherAlerts.SET_IS_PENDING)
  );
}

export function getFieldWeatherAlerts(fieldId, params, sourceId) {
  return getWeatherAlerts(
    `${urlsWrapper('fields')}/${fieldId}/weather/${sourceId}/alerts?${serialize(
      params
    )}`,
    createAction(fieldWeatherAlerts.SET_LIST),
    createAction(fieldWeatherAlerts.SET_IS_PENDING)
  );
}

export function getWeatherSources() {
  return saveData(
    `${urlsWrapper('weatherSources')}`,
    divisionWeatherSources.SET_LIST,
    divisionWeatherSources.SET_IS_PENDING
  );
}

export function getDivisionWeatherSources(divisionId) {
  return saveData(
    `${urlsWrapper('divisions')}/${divisionId}/weather/sources`,
    divisionWeatherSources.SET_LIST,
    divisionWeatherSources.SET_IS_PENDING
  );
}

export async function getFieldWeatherSources(fieldId) {
  const { data } = await commonGet({
    url: `${urlsWrapper('fields')}/${fieldId}/weather/sources`,
  }).catch(() => []);
  return data;
}

// selectors
export const getWeatherGeojsonSelector = (state) =>
  state.weather.weatherGeojson;
